// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Button } from './ui/button';
// import { getProducts } from '../api';

// const TourDatesSection = () => {
//   const [tours, setTours] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchTours = async () => {
//       try {
//         const data = await getProducts({ category: 'tour' });
//         setTours(data);
//       } catch (error) {
//         console.error('Error fetching tours:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTours();
//   }, []);

//   if (loading) {
//     return (
//       <section id="tour-dates" className="w-full bg-gradient-to-br from-orange-400 to-orange-500 py-20 px-6">
//         <div className="max-w-7xl mx-auto text-center text-white">
//           <p className="text-2xl">Loading tour dates...</p>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <section id="tour-dates" className="w-full relative py-20 px-6 overflow-hidden">
//       {/* Gradient Background with Darker Shade */}
//       <div className="absolute inset-0 bg-gradient-to-br from-orange-400 via-orange-500 to-orange-600"></div>
//       <div className="absolute inset-0 bg-gradient-to-b from-transparent via-orange-600/20 to-orange-700/40"></div>
      
//       <div className="max-w-7xl mx-auto relative z-10">
//         {/* Section Header with Background Boxes */}
//         <div className="mb-12">
//           {/* H2 - Judul with lighter background */}
//           <div className="bg-orange-500/50 backdrop-blur-sm rounded-2xl p-6 mb-4">
//             <h2 className="text-5xl md:text-7xl font-bold text-white">
//               TOUR DATES
//             </h2>
//           </div>
          
//           {/* H3 + Button + Image - All in darker background box */}
//           <div className="bg-orange-700/70 backdrop-blur-sm rounded-2xl p-6">
//             {/* H3 and Button */}
//             <div className="flex flex-col md:flex-row items-start md:items-center gap-4 mb-6">
//               <h3 className="text-2xl md:text-3xl font-bold text-white">
//                 ACTING MY AGE TOUR
//               </h3>
//               <Button
//                 className="bg-black text-white hover:bg-gray-900 rounded-full px-8 py-3 text-sm font-semibold transition-all duration-200"
//               >
//                 Buy Tickets
//               </Button>
//             </div>
            
//             {/* Tour Banner Image inside the same dark box */}
//             <div className="rounded-lg overflow-hidden shadow-2xl">
//               <img
//                 src="https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?w=1200&q=80"
//                 alt="Acting My Age Tour"
//                 className="w-full h-64 md:h-96 object-cover"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Tour Dates List */}
//         {tours.length > 0 ? (
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {tours.map((tour) => (
//               <div
//                 key={tour.id}
//                 onClick={() => navigate(`/product/${tour.id}`)}
//                 className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-all duration-300 border border-white/20 cursor-pointer"
//               >
//                 <div className="text-white">
//                   <p className="text-lg font-bold mb-2">{tour.date}</p>
//                   <p className="text-xl font-semibold mb-1">{tour.location}</p>
//                   <p className="text-sm mb-4 opacity-90">{tour.venue}</p>
//                   {tour.status === 'sold-out' ? (
//                     <div className="inline-block px-4 py-2 bg-gray-800 text-white rounded-full text-sm font-semibold">
//                       SOLD OUT
//                     </div>
//                   ) : (
//                     <Button
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         navigate(`/product/${tour.id}`);
//                       }}
//                       className="bg-black text-white hover:bg-gray-900 rounded-full px-6 py-2 text-sm font-semibold transition-all duration-200"
//                     >
//                       Get Tickets
//                     </Button>
//                   )}
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <div className="text-center text-white py-12">
//             <p className="text-2xl">No tour dates available at the moment.</p>
//             <p className="text-lg mt-2">Check back soon for updates!</p>
//           </div>
//         )}
//       </div>
//     </section>
//   );
// };

// export default TourDatesSection;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { getProducts, getSection } from '@/api';

const TourDatesSection = () => {
  const [tours, setTours] = useState([]);
  const [banner, setBanner] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch both products and the banner section data concurrently
        const [productsData, bannerData] = await Promise.all([
          getProducts({ category: 'tour' }),
          getSection('tour_banner').catch(() => null) // Handle error gracefully if section missing
        ]);
        
        setTours(productsData);
        setBanner(bannerData);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Default values if API returns null (fallback)
  const defaultImage = "https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?w=1200&q=80";
  const displayImage = banner?.image || defaultImage;
  const displayMainTitle = banner?.title || "TOUR DATES";
  const displaySubTitle = banner?.subtitle || "ACTING MY AGE TOUR";

  if (loading) {
    return (
      <section id="tour-dates" className="w-full bg-gradient-to-br from-orange-400 to-orange-500 py-20 px-6">
        <div className="max-w-7xl mx-auto text-center text-white">
          <p className="text-2xl">Loading tour dates...</p>
        </div>
      </section>
    );
  }

  return (
    <section id="tour-dates" className="w-full relative py-20 px-6 overflow-hidden">
      {/* Gradient Background with Darker Shade */}
      <div className="absolute inset-0 bg-gradient-to-br from-orange-400 via-orange-500 to-orange-600"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-orange-600/20 to-orange-700/40"></div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header with Background Boxes */}
        <div className="mb-12">
          {/* H2 - Judul with lighter background */}
          <div className="bg-orange-500/50 backdrop-blur-sm rounded-2xl p-6 mb-4">
            <h2 className="text-5xl md:text-7xl font-bold text-white uppercase">
              {displayMainTitle}
            </h2>
          </div>
          
          {/* H3 + Button + Image - All in darker background box */}
          <div className="bg-orange-700/70 backdrop-blur-sm rounded-2xl p-6">
            {/* H3 and Button */}
            <div className="flex flex-col md:flex-row items-start md:items-center gap-4 mb-6">
              <h3 className="text-2xl md:text-3xl font-bold text-white uppercase">
                {displaySubTitle}
              </h3>
              <Button
                className="bg-black text-white hover:bg-gray-900 rounded-full px-8 py-3 text-sm font-semibold transition-all duration-200"
                onClick={() => {
                   // If you want the button to use the link from DB:
                   if (banner?.link && banner.link !== '#') {
                     window.open(banner.link, '_blank');
                   }
                }}
              >
                Buy Tickets
              </Button>
            </div>
            
            {/* Tour Banner Image inside the same dark box */}
            <div className="rounded-lg overflow-hidden shadow-2xl">
              <img
                src={displayImage}
                alt={displaySubTitle}
                className="w-full h-64 md:h-96 object-cover"
              />
            </div>
          </div>
        </div>

        {/* Tour Dates List */}
        {tours.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {tours.map((tour) => (
              <div
                key={tour.id}
                onClick={() => navigate(`/product/${tour.id}`)}
                className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-all duration-300 border border-white/20 cursor-pointer"
              >
                <div className="text-white">
                  <p className="text-lg font-bold mb-2">{tour.date}</p>
                  <p className="text-xl font-semibold mb-1">{tour.location}</p>
                  <p className="text-sm mb-4 opacity-90">{tour.venue}</p>
                  {tour.status === 'sold-out' ? (
                    <div className="inline-block px-4 py-2 bg-gray-800 text-white rounded-full text-sm font-semibold">
                      SOLD OUT
                    </div>
                  ) : (
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/product/${tour.id}`);
                      }}
                      className="bg-black text-white hover:bg-gray-900 rounded-full px-6 py-2 text-sm font-semibold transition-all duration-200"
                    >
                      Get Tickets
                    </Button>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center text-white py-12">
            <p className="text-2xl">No tour dates available at the moment.</p>
            <p className="text-lg mt-2">Check back soon for updates!</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default TourDatesSection;